<template>
  <div class="textAreaField">
    <label>{{ label }}</label>
    <textarea
      class="inputTextArea"
      rows="3"
      :value="value"
      @input="$emit('update:value', $event.target.value)"
    ></textarea>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: {
      type: [String, Number],
      default: "",
    },
  },
};
</script>

<style scoped>
.textAreaField {
  position: relative;
  width: 100%;
}

label {
  background: white;
  color: #555151;
  font-size: 9px;
  font-weight: 600;
  left: 10px;
  padding: 0 3px;
  position: absolute;
  top: -7px;
  z-index: 1;
}

.inputTextArea {
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  color: #5c5855;
  font-size: 12px;
  height: 75px;
  outline: none;
  padding: 7px 5px;
  resize: none;
  width: 100%;
}
</style>
